module.exports = __webpack_public_path__ + "img/inspiring_background_mobile@2x.ae39268.jpg";